export {
  default as subtaskItemArtTemplateReducer,
} from './subtaskItemArtTemplate.reducer';
export { default as watchSubtaskItemArtTemplateMoq } from './subtaskItemArtTemplate.saga';
export * from './subtaskItemArtTemplate.type';
export * from './subtaskItemArtTemplate.actions';
